import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "./motionUtils";
import { resume } from "../data/resume";

// exporting unit test-id for Jest Testing Library
export const EDUCATION_TEST_ID = "EDUCATION_TEST_ID";

export const Education = () => {
  return (
    <div className="w-full flex flex-col space-y-1 font-poppins font-thin text-sm sm:text-base">
      <motion.div
        variants={fadeIn("right", "tween", 0, 1.5)}
        whileInView="show"
        initial="hidden"
        viewport={{ once: false, amount: 0.05 }}
        className="w-full"
        data-testid={EDUCATION_TEST_ID}
      >
        <div className="flex flex-col sm:flex-row font-lora font-bold">
          <h1 className="text-sm md:text-lg lg:text-base">
            <span className="font-bold">
              {resume.education.university_name}
            </span>{" "}
            - <span>{resume.education.location}</span>
          </h1>
          <h1 className="text-sm md:text-lg lg:text-base">
            <i>{`—${resume.education.degree}`}</i>
          </h1>
        </div>
        <p className="uppercase text-xs sm:text-[0.7rem] font-semibold">
          {`${resume.education.start_date} - ${resume.education.end_date}`}
        </p>
        <p>{resume.education.text}</p>
        <br />
        <br />
      </motion.div>
    </div>
  );
};
